export const openCases = [
  {
    label: "Basic Details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
  {
    label: "Policy Details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
  {
    label: "Proposal Details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
  {
    label: "Dispatch Details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
  {
    label: "Claim details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
  {
    label: "Risk Details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
  {
    label: "Endorsement Details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
  {
    label: "CHASE Smart",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/23-23/23300",
      },
      {
        label: "policy start date",
        value: "last week",
      },
      {
        label: "Policy status",
        value: "Active",
      },
      {
        label: "claim number",
        value: "case/34/45/900",
      },
      {
        label: "policy end date",
        value: "last week",
      },
      {
        label: "policy issue date",
        value: "last week",
      },
    ],
  },
];

// export const assignBlock = [
//   {
//     id: 1,
//     label: "Accident Spot Verification",
//   },
//   {
//     id: 2,
//     label: "Case brief 1",
//   },
//   {
//     id: 3,
//     label: "Case Comments",
//   },
//   {
//     id: 4,
//     label: "Case status history",
//   },
//   {
//     id: 5,
//     label: "FIR / GD",
//   },
//   {
//     id: 6,
//     label: "Insured details",
//   },
//   {
//     id: 7,
//     label: "Charge sheet details",
//   },
//   {
//     id: 8,
//     label: "Claimant details",
//   },
//   {
//     id: 9,
//     label: "Details MVI Reports",
//   },
//   {
//     id: 10,
//     label: "Eye Witness",
//   },
//   {
//     id: 11,
//     label: "Fraud / Supected Fraud / Loss minimization",
//   },
//   {
//     id: 12,
//     label: "File Submission History",
//   },
//   {
//     id: 13,
//     label: "Income details",
//   },
//   {
//     id: 14,
//     label: "Invoice",
//   },
//   {
//     id: 15,
//     label: "MLC details",
//   },
//   {
//     id: 16,
//     label: "IV Driver details",
//   },
//   {
//     id: 17,
//     label: "IV Policy details",
//   },
//   {
//     id: 18,
//     label: "IV Permit details",
//   },
//   {
//     id: 19,
//     label: "IV RC details",
//   },
// ];
export const basicCases = [
  {
    label: "Basic Details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Policy Start Date",
        value: "last week",
      },
      {
        label: "Policy Status",
        value: "Active",
      },
      {
        label: "Claim Number",
        value: "CASE/879/797",
      },
      {
        label: "Policy End Date",
        value: "last week",
      },
      {
        label: "Policy Issue Date",
        value: "last week",
      },
    ],
  },
];

export const policyCases = [
  {
    label: "Policy Details",
    tabComponent: [
      {
        label: "Policy Number",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Total Premium",
        value: "last week",
      },
      {
        label: "Policy Type",
        value: "Active",
      },
      {
        label: "Policy Start Date",
        value: "CASE/879/797",
      },
      {
        label: "Policy End Date",
        value: "last week",
      },
      {
        label: "Policy inception date",
        value: "last week",
      },
      {
        label: "Policy Number",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Total Premium",
        value: "last week",
      },
      {
        label: "LOB",
        value: "Active",
      },
      {
        label: "Product Name",
        value: "CASE/879/797",
      },
      {
        label: "Sub Product Plan Name",
        value: "last week",
      },
      {
        label: "Policy Term/Tenure",
        value: "last week",
      },
      {
        label: "Hypothecation With",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Total Sum Insured",
        value: "last week",
      },
      {
        label: "CB Amount",
        value: "Active",
      },
      {
        label: "NCB Amount",
        value: "CASE/879/797",
      },
      {
        label: "Insured Details",
        value: "last week",
      },
      {
        label: "Customer Reg. Mobile No.",
        value: "last week",
      },
      {
        label: "Customer Reg. Email ID",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Customer Address",
        value: "last week",
      },
      {
        label: "Customer State",
        value: "Active",
      },
      {
        label: "Customer City",
        value: "CASE/879/797",
      },
      {
        label: "Customer Pincode",
        value: "last week",
      },
      {
        label: "Nominee Details",
        value: "last week",
      },
    ],
  },
];

export const proposalCases = [
  {
    label: "Proposal Details",
    tabComponent: [
      {
        label: "Previous Policy Details",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Previous Policy Number",
        value: "last week",
      },
      {
        label: "Start Date",
        value: "Active",
      },
      {
        label: "End Date",
        value: "CASE/879/797",
      },
      {
        label: "Inspection Status",
        value: "last week",
      },
      {
        label: "Survey Report",
        value: "last week",
      },
      {
        label: "Break In (PI Report)",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Inspection  - Photo Image",
        value: "last week",
      },
      {
        label: "PROPOSAL NO",
        value: "Active",
      },
      {
        label: "PROPOSAL NO",
        value: "CASE/879/797",
      },
      {
        label: "Diagnostic Reports",
        value: "last week",
      },
      {
        label: "UW_REMARKS",
        value: "last week",
      },
      {
        label: "PROPOSAL_STATUS",
        value: "case/2022-10-13/55113",
      },
      {
        label: "INTERMEDIARY_NAME",
        value: "last week",
      },
      {
        label: "INTERMEDIARY_Code",
        value: "Active",
      },
      {
        label: "PRIMARY_SALES_MANAGER",
        value: "CASE/879/797",
      },
      {
        label: "SECONDARY_SALES_MANAGER",
        value: "last week",
      },
    ],
  },
];

export const riskCases = [
  {
    label: "Risk Details",
    tabComponent: [
      {
        label: "Deductible",
        value: "case/2022-10-13/55113",
      },
      {
        label: "RTO Location",
        value: "last week",
      },
      {
        label: "Seating Capacity",
        value: "Active",
      },
      {
        label: "Vehicle  Model – Variant",
        value: "CASE/879/797",
      },
      {
        label: "Manufacturing Year",
        value: "last week",
      },
      {
        label: "CC Capacity",
        value: "last week",
      },
      {
        label: "Vehicle Make",
        value: "case/2022-10-13/55113",
      },
      {
        label: "IDV",
        value: "last week",
      },
      {
        label: "Name of Proposer",
        value: "Active",
      },
      {
        label: "Customer Name",
        value: "CASE/879/797",
      },
      {
        label: "Name of All Insured",
        value: "last week",
      },
      {
        label: "Type of Insured",
        value: "last week",
      },
      {
        label: "Relationship",
        value: "case/2022-10-13/55113",
      },
      {
        label: "DOB",
        value: "last week",
      },
      {
        label: "Sum Insured",
        value: "Active",
      },
      {
        label: "Coverage  Name",
        value: "CASE/879/797",
      },
      {
        label: "Vehicle Chasis No",
        value: "last week",
      },
      {
        label: "Registration Date",
        value: "last week",
      },
    ],
  },
];

export const externalCases = [
  {
    label: "External Details",
    tabComponent: [
      {
        label: "Driver Extract & Validity",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Type of Licence",
        value: "last week",
      },
      {
        label: "DL Verification",
        value: "Active",
      },
      {
        label: "RC Ver. Permit Verification",
        value: "CASE/879/797",
      },
      {
        label: "Fitness Verification",
        value: "last week",
      },
      {
        label: "Insurance Details & Validity of Insurance",
        value: "last week",
      },
      {
        label: "Company Name",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Policy Number",
        value: "last week",
      },
      {
        label: "Category",
        value: "Active",
      },
      {
        label: "Pan Verification",
        value: "CASE/879/797",
      },
      {
        label: "Blacklist Status",
        value: "last week",
      },
      {
        label: "ITR Validation",
        value: "last week",
      },
      {
        label: "Customer PAN Number",
        value: "case/2022-10-13/55113",
      },
      {
        label: "Phone Number",
        value: "last week",
      },
      {
        label: "Customer Full Name",
        value: "Active",
      },
      {
        label: "Address",
        value: "CASE/879/797",
      },
      {
        label: "Voter ID",
        value: "last week",
      },
      {
        label: "CRIF Report",
        value: "last week",
      },
      {
        label: "CB Amount",
        value: "last week",
      },
      {
        label: "Trace Lost Vehicle",
        value: "Active",
      },
      {
        label: "Flag in CIMA",
        value: "CASE/879/797",
      },
    ],
  },
];

function caseNumberClick() {}
function createCaseClick() {}
export const columnsData = [
  {
    id: "srNo",
    label: "Sr. No",
    align: "left",
    fontSize: "10px",
  },
  {
    id: "caseNo",
    label: "Case No.",
    align: "left",
    color: "red",
    fontSize: "10px",
    cursor: "pointer",
    onClick: caseNumberClick,
  },
  {
    id: "customerName",
    label: "Customer Namejhghhjjjjjjhk",

    align: "left",
    fontSize: "10px",
  },
  {
    id: "caseCreatedBy",
    label: "Case Created By",

    align: "left",
    fontSize: "10px",
  },
  {
    id: "tiggerScore",
    label: "Tigger Score",

    align: "left",
    fontSize: "12px",
  },
  {
    id: "lob",
    label: "LOBjhjhjhkj",

    align: "left",
    fontSize: "10px",
  },
  {
    id: "product",
    label: "Product",

    align: "left",
    fontSize: "10px",
  },
  {
    id: "lossLocation",
    label: "Loss Location",

    align: "left",
    fontSize: "10px",
  },
  {
    id: "assignedDate",
    label: "Assigned Date",

    align: "left",
    fontSize: "10px",
  },
  {
    id: "tat",
    label: "TAT",

    align: "center",
    fontSize: "10px",
  },
  {
    id: "customerSegment",
    label: "Customer Segment",

    align: "left",
    fontSize: "10px",
  },
  {
    id: "regDate",
    label: "Reg Date",

    align: "left",
  },
  {
    id: "alert",
    label: "Alert",

    align: "center",
    fontSize: "10px",
  },
];

export const plainColumnsDataClaimDetails = [
  {
    id: "srNo",
    label: "Sr. No",
    align: "left",
  },
  {
    id: "claim_number",
    label: "Claim_Number:",
    align: "left",
  },
  {
    id: "lossDate",
    label: "Loss Date:",
    align: "left",
  },
  {
    id: "registrationDate",
    label: "Registration Date:",
    align: "left",
  },
  {
    id: "claimRegisteredBy",
    label: "Claim registered by:",
    align: "left",
  },
  {
    id: "blank",
    label: " ",
    align: "right",
    color: "#1395CC",
    cursor: "pointer",
  },
  {
    id: "blank2",
    fontSize: " ",
    align: "left",
    color: "#1395CC",
    cursor: "pointer",
    // onClick: createCaseClick,
  },
];
function createData(
  srNo,
  caseNo,
  customerName,
  caseCreatedBy,
  tiggerScore,
  lob,
  product,
  lossLocation,
  assignedDate,
  tat,
  customerSegment,
  regDate,
  alert,
  code
) {
  return {
    srNo,
    caseNo,
    customerName,
    caseCreatedBy,
    tiggerScore,
    lob,
    product,
    lossLocation,
    assignedDate,
    tat,
    customerSegment,
    regDate,
    alert,
    code,
  };
}

export const plainRowsDataClaimDetails = [
  {
    srNo: "1",
    claim_number: "case/2022-10-13/55113",
    lossDate: "last week",
    registrationDate: "Active",
    claimRegisteredBy: "CASE/879/797",
    blank: "View Details",
    blank2: "Create Case",
  },
  {
    srNo: "2",
    claim_number: "case/2022-10-13/55113",
    lossDate: "last week",
    registrationDate: "Active",
    claimRegisteredBy: "CASE/879/797",
    blank: "View Details",
    blank2: "Create Case",
  },
  {
    srNo: "3",
    claim_number: "case/2022-10-13/55113",
    lossDate: "last week",
    registrationDate: "Active",
    claimRegisteredBy: "CASE/879/797",
    blank: "View Details",
    blank2: "Create Case",
  },
  {
    srNo: "4",
    claim_number: "case/2022-10-13/55113",
    lossDate: "last week",
    registrationDate: "Active",
    claimRegisteredBy: "CASE/879/797",
    blank: "View Details",
    blank2: "Create Case",
  },
  {
    srNo: "5",
    claim_number: "case/2022-10-13/55113",
    lossDate: "last week",
    registrationDate: "Active",
    claimRegisteredBy: "CASE/879/797",
    blank: "View Details",
    blank2: "Create Case",
  },
];

export const popOverActionList = [
  "Raise Query",
  "Re-assign",
  "Case History",
  "Case Description",
  "Assign Block",
  "Upload Documents",
  "Grade Case",
  "Submit Final",
  "Approve",
  "Vendor Asseement",
  "Reject",
  "Re-open",
];
export const popOverCaseCTA = ["view", "action"];
export const plainColumnsDataDispatchDetails = [
  {
    id: "srNo",
    label: "Sr. No",
    align: "left",
  },
  {
    id: "dispatchDate",
    label: "Dispatch Date:",
    align: "left",
  },
  {
    id: "deliveryDate",
    label: "Delivery Date:",
    align: "left",
  },
  {
    id: "dispatchType",
    label: "Dispatch Type:",
    align: "left",
  },
  {
    id: "firstReturnDate",
    label: "First Return Date:",
    align: "left",
  },
  {
    id: "blank",
    label: " ",
    align: "left",
    color: "#1395CC",
    cursor: "pointer",
  },
];

export const plainRowsDataDispatchDetails = [
  {
    srNo: "1",
    dispatchDate: "case/2022-10-13/55113",
    deliveryDate: "last week",
    dispatchType: "Active",
    firstReturnDate: "CASE/879/797",
    blank: "View Details",
  },
  {
    srNo: "2",
    dispatchDate: "case/2022-10-13/55113",
    deliveryDate: "last week",
    dispatchType: "Active",
    firstReturnDate: "CASE/879/797",
    blank: "View Details",
  },
  {
    srNo: "3",
    dispatchDate: "case/2022-10-13/55113",
    deliveryDate: "last week",
    dispatchType: "Active",
    firstReturnDate: "CASE/879/797",
    blank: "View Details",
  },
  {
    srNo: "4",
    dispatchDate: "case/2022-10-13/55113",
    deliveryDate: "last week",
    dispatchType: "Active",
    firstReturnDate: "CASE/879/797",
    blank: "View Details",
  },
  {
    srNo: "5",
    dispatchDate: "case/2022-10-13/55113",
    deliveryDate: "last week",
    dispatchType: "Active",
    firstReturnDate: "CASE/879/797",
    blank: "View Details",
  },
];

export const tableGridDispatchDetails = [
  {
    label: "POD NO",
    value: "last week",
  },
  {
    label: "Delivery Status",
    value: "case/2022-10-13/55113",
  },
  {
    label: "COURIER",
    value: "last week",
  },
];

export const plainColumnsDataEndorsementDetails = [
  {
    id: "srNo",
    label: "Sr. No",
    align: "left",
  },
  {
    id: "endorsementNo",
    label: "Endorsement No:",
    align: "left",
  },
  {
    id: "typeOfEndorsement",
    label: "Type Of Endorsement:",
    align: "left",
  },
  {
    id: "transactionDate",
    label: "Transaction Date:",
    align: "left",
  },
  {
    id: "premiumAmt",
    label: "Premium Amt:",
    align: "left",
  },
  {
    id: "blank",
    label: " ",
    align: "left",
    color: "#1395CC",
    cursor: "pointer",
  },
];

export const plainRowsDataEndorsementDetails = [
  {
    srNo: "1",
    endorsementNo: "case/2022-10-13/55113",
    typeOfEndorsement: "last week",
    transactionDate: "Active",
    premiumAmt: "CASE/879/797",
    blank: "View Details",
  },
  {
    srNo: "2",
    endorsementNo: "case/2022-10-13/55113",
    typeOfEndorsement: "last week",
    transactionDate: "Active",
    premiumAmt: "CASE/879/797",
    blank: "View Details",
  },
  {
    srNo: "3",
    endorsementNo: "case/2022-10-13/55113",
    typeOfEndorsement: "last week",
    transactionDate: "Active",
    premiumAmt: "CASE/879/797",
    blank: "View Details",
  },
  {
    srNo: "4",
    endorsementNo: "case/2022-10-13/55113",
    typeOfEndorsement: "last week",
    transactionDate: "Active",
    premiumAmt: "CASE/879/797",
    blank: "View Details",
  },
  {
    srNo: "5",
    endorsementNo: "case/2022-10-13/55113",
    typeOfEndorsement: "last week",
    transactionDate: "Active",
    premiumAmt: "CASE/879/797",
    blank: "View Details",
  },
];

export const tableGridEndorsementDetails = [
  {
    label: "Premium _ Non-premium bearing",
    value: "last week",
  },
  {
    label: "Endorsement Reason",
    value: "last week",
  },
];

export const rowsData = [
  createData(
    5,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        fill="#E42125"
      />
      <path
        d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        fill="#FFFCF2"
      />
      <path
        d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        fill="#FFFCF2"
      />
    </svg>
  ),
  createData(
    6,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    "-"
  ),
  createData(
    7,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        fill="#E42125"
      />
      <path
        d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        fill="#FFFCF2"
      />
      <path
        d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        fill="#FFFCF2"
      />
    </svg>
  ),
  createData(
    8,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        fill="#E42125"
      />
      <path
        d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        fill="#FFFCF2"
      />
      <path
        d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        fill="#FFFCF2"
      />
    </svg>
  ),
  createData(
    9,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    "-"
  ),

  createData(
    5,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        fill="#E42125"
      />
      <path
        d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        fill="#FFFCF2"
      />
      <path
        d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        fill="#FFFCF2"
      />
    </svg>
  ),
  createData(
    5,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    "-"
  ),
  createData(
    5,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        fill="#E42125"
      />
      <path
        d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        fill="#FFFCF2"
      />
      <path
        d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        fill="#FFFCF2"
      />
    </svg>
  ),
  createData(
    5,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        fill="#E42125"
      />
      <path
        d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        fill="#FFFCF2"
      />
      <path
        d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        fill="#FFFCF2"
      />
    </svg>
  ),
  createData(
    5,
    25,
    "PARAMESH VERAPPA H C",
    "IM",
    "HRE",
    "Claim Type 1",
    "Motor",
    "Karnataka",
    "02/10/2022",
    2,
    "Women",
    "02/10/2022",
    "-"
  ),
];

export const tabsCaseManagement = [
  {
    label: "20 Open",
  },
  {
    label: "20 Allocated",
  },
  {
    label: "20 QC",
  },
  {
    label: "20 Query",
  },
  {
    label: "20 Recommended",
  },
  {
    label: "20 Submitted",
  },
  {
    label: "20 Rejected",
  },
];

export const tabs2CaseManagement = [
  {
    label: "Basic Details",
  },
  {
    label: "Policy Details",
  },
  {
    label: "Proposal Details",
  },
  {
    label: "Dispatch Details",
  },
  {
    label: "Claim details",
  },
  {
    label: "Risk Details",
  },
  {
    label: "Endorsement Details",
  },
  {
    label: "CHASE Smart",
  },
];

export const invoiceTableData = [
  {
    //De-empanel Hospital
    column: [
      { id: "select", label: "Select", align: "left" },
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "hsname_var",
        minWidth: "10rem",
        label: "Hospital Name",
        align: "left",
        cursor: "pointer",
      },
      {
        id: "hsaddress1_var",
        label: "Address",
        align: "left",
      },

      {
        id: "txt_state",
        label: "State",
        align: "left",
      },
      {
        id: "txt_citydistrict",
        label: "City",
        align: "left",
      },
      {
        id: "hspincode_num",
        label: "Pin Code",
        align: "center",
      },
      {
        id: "pan",
        label: "PAN",
        align: "center",
      },
      {
        id: "nspid_var",
        label: "Hospital Code",
        align: "center",
      },
    ],
    // 7
    row: [
      {
        select: <input type="checkbox" />,
        srNo: 5,
        hospitalName: "hospital",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pinCode: 400065,
        pan: "CJIPAXXX3K",
        hospitalCode: "JBJHG543HJMBXXX",
      },
      {
        select: <input type="checkbox" />,
        srNo: 5,
        hospitalName: "hospital",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pinCode: 400065,
        pan: "CJIPAXXX3K",
        hospitalCode: "JBJHG543HJMBXXX",
      },
      {
        select: <input type="checkbox" />,
        srNo: 5,
        hospitalName: "hospital",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pinCode: 400065,
        pan: "CJIPAXXX3K",
        hospitalCode: "JBJHG543HJMBXXX",
      },
      {
        select: <input type="checkbox" />,
        srNo: 5,
        hospitalName: "hospital",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pinCode: 400065,
        pan: "CJIPAXXX3K",
        hospitalCode: "JBJHG543HJMBXXX",
      },
      {
        select: <input type="checkbox" />,
        srNo: 5,
        hospitalName: "hospital",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pinCode: 400065,
        pan: "CJIPAXXX3K",
        hospitalCode: "JBJHG543HJMBXXX",
      },
    ],
  },
  {
    //De-empanel Garage
    column: [
      { id: "select", label: "Select", align: "left" },
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "name",
        minWidth: "10rem",
        label: "Garage Name",
        align: "left",
        cursor: "pointer",
      },
      {
        id: "address",
        label: "Address",
        align: "left",
      },

      {
        id: "state",
        label: "State",
        align: "left",
      },
      {
        id: "city",
        label: "City",
        align: "left",
      },
      {
        id: "pincode",
        label: "Pin Code",
        align: "center",
      },
      {
        id: "pan",
        label: "PAN",
        align: "center",
      },
      {
        id: "garage_code",
        label: "Garage Code",
        align: "center",
      },
    ],
    // 7
    row: [
      {
        select: <input type="checkbox" />,
        srNo: 5,
        name: "garage",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pincode: 400065,
        pan: "CJIPAXXX3K",
        garage_code: "JBJHG543HJMBXXX",
      },
      {
        select: <input type="checkbox" />,
        srNo: 5,
        name: "garage",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pincode: 400065,
        pan: "CJIPAXXX3K",
        garage_code: "JBJHG543HJMBXXX",
      },
      {
        select: <input type="checkbox" />,
        srNo: 5,
        name: "garage",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pincode: 400065,
        pan: "CJIPAXXX3K",
        garage_code: "JBJHG543HJMBXXX",
      },
      {
        select: <input type="checkbox" />,
        srNo: 5,
        name: "garage",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pincode: 400065,
        pan: "CJIPAXXX3K",
        garage_code: "JBJHG543HJMBXXX",
      },
      {
        select: <input type="checkbox" />,
        srNo: 5,
        name: "garage",
        address: "address",
        state: "Maharashtra",
        city: "Mumbai",
        pincode: 400065,
        pan: "CJIPAXXX3K",
        garage_code: "JBJHG543HJMBXXX",
      },
    ],
  },
];

export const recommendationsTabelData = {
  Hospital: {
    row: {
      SrNo: "Sr.No",
      hsname_var: "Hospital Name",
      hospital_id: "Hospital Code",
      im_decision: "IM - Action View Recommendation",
      rm_decision: "RM - Action View Recommendation",
      nm_decision: "NM - Action View Recommendation",
      nh_decision: "NH - Action View Recommendation",
      txt_state: "State",
      txt_citydistrict: "City",
      hspincode_num: "Pincode",
      hsaddress1_var: "Address",
    },
    column: [
      {
        id: 1,
        hsname_var: "King George's Medical University",
        hospital_id: "001",
        im_decision: "Approved",
        rm_decision: "Approved",
        nm_decision: "Rejected",
        txt_state: "Maharashtra",
        txt_citydistrict: "Mumbai",
        hspincode_num: "123456",
        hsaddress1_var: "Address",
      },
      {
        id: 2,
        hsname_var: "King George's Medical University",
        hospital_id: "001",
        im_decision: "Approved",
        rm_decision: "Approved",
        nm_decision: "Rejected",
        txt_state: "Maharashtra",
        txt_citydistrict: "Mumbai",
        hspincode_num: "123456",
        hsaddress1_var: "Address",
      },
      {
        id: 3,
        hsname_var: "King George's Medical University",
        hospital_id: "001",
        im_decision: "Approved",
        rm_decision: "Approved",
        nm_decision: "Rejected",
        txt_state: "Maharashtra",
        txt_citydistrict: "Mumbai",
        hspincode_num: "123456",
        hsaddress1_var: "Address",
      },
    ],
  },
  Garage: {
    row: {
      SrNo: "Sr.No",
      name: "Garage Name",
      garage_id: "Garage Code",
      im_decision: "IM - Action View Recommendation",
      qc_decision: "QC - Action View Recommendation",
      rm_decision: "RM - Action View Recommendation",
      nm_decision: "NM - Action View Recommendation",
      state: "State",
      city: "City",
      pincode: "Pincode",
      Address: "Address",
    },
    column: [
      {
        id: 1,
        name: "King George's Medical University",
        garage_id: "001",
        im_decision: "Approved",
        rm_decision: "Approved",
        nm_decision: "Rejected",
        state: "Maharashtra",
        city: "Mumbai",
        pincode: "123456",
        Address: "Address",
      },
      {
        id: 2,
        name: "King George's Medical University",
        garage_id: "001",
        im_decision: "Approved",
        rm_decision: "Approved",
        nm_decision: "Rejected",
        state: "Maharashtra",
        city: "Mumbai",
        pincode: "123456",
        Address: "Address",
      },
      {
        id: 3,
        name: "King George's Medical University",
        garage_id: "001",
        im_decision: "Rejected",
        rm_decision: "Approved",
        nm_decision: "Rejected",
        state: "Maharashtra",
        city: "Mumbai",
        pincode: "123456",
        Address: "Address",
      },
    ],
  },
  UserRoleMapping: {
    im_decision: "IM",
    qc_decision: "QC",
    rm_decision: "RM",
    nm_decision: "NM",
    nh_decision: "NH",
  },
};

export const RLMUActionsTabelData = {
  Hospital: {
    row: {
      SrNo: "Sr.No",
      name: "Name",
      case_grade: "Case Grade",
      fraud: "Fraud Type",
      grade_status: "Grade Status",
      grade_sub_status: "Grade Sub-Status",
      vendor_assessment: "Vendor Assessment",
      regulatory_details: "Regulatory Details",
      peer_review: "Peer Review",
    },
    column: [
      {
        id: 1,
        name: "Ram Singh - IM",
        case_grade: "Grade 1 : Fraud",
        grade_status: "Grade 1 : Fraud",
        grade_sub_status: "Grade 1 : Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 2,
        name: "Venkata Narasimha Singh - RM",
        case_grade: "Grade 2 : Loss Minimization",
        grade_status: "Documentary Fraud",
        grade_sub_status: "Documentary Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 3,
        name: "Vijay Sharma - NM",
        case_grade: "Vijay Sharma - NM",
        grade_status: "Fake Hospitalisation",
        grade_sub_status: "No Employee Employer Relationship",
        vendor_assessment: "Vendor Assessment",
      },
    ],
    vendorAssessments: {
      row: {
        vendor_name: "Vendor Name",
        report_status: "Report Status",
        report_standard: "Report Standard",
        report_standard_score: "Report Standard Score",
        company_name: "Company name",
        block_completed: "Block Completed",
        block_score: "Block Score",
        quality_score: "Quality Score",
        remarks: "Remarks",
      },
      column: [
        {
          vendor_name: "Akash Sharma",
          report_status: "Fraud",
          report_standard: "Very Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Fraud",
          report_standard: "Below Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Policy Violation",
          report_standard: "Excellent",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Fair",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
      ],
    },
  },
  Garage: {
    row: {
      SrNo: "Sr.No",
      name: "Name",
      case_grade: "Case Grade",
      fraud: "Fraud Type",
      grade_status: "Grade Status",
      grade_sub_status: "Grade Sub-Status",
      vendor_assessment: "Vendor Assessment",
      regulatory_details: "Regulatory Details",
      peer_review: "Peer Review",
    },
    column: [
      {
        id: 1,
        name: "Ram Singh - IM",
        case_grade: "Grade 1 : Fraud",
        grade_status: "Grade 1 : Fraud",
        grade_sub_status: "Grade 1 : Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 2,
        name: "Venkata Narasimha Singh - RM",
        case_grade: "Grade 2 : Loss Minimization",
        grade_status: "Documentary Fraud",
        grade_sub_status: "Documentary Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 3,
        name: "Vijay Sharma - NM",
        case_grade: "Vijay Sharma - NM",
        grade_status: "Fake Hospitalisation",
        grade_sub_status: "No Employee Employer Relationship",
        vendor_assessment: "Vendor Assessment",
      },
    ],
    vendorAssessments: {
      row: {
        vendor_name: "Vendor Name",
        report_status: "Report Status",
        report_standard: "Report Standard",
        report_standard_score: "Report Standard Score",
        company_name: "Company name",
        block_completed: "Block Completed",
        block_score: "Block Score",
        quality_score: "Quality Score",
        remarks: "Remarks",
      },
      column: [
        {
          vendor_name: "Akash Sharma",
          report_status: "Fraud",
          report_standard: "Very Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Fraud",
          report_standard: "Below Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Policy Violation",
          report_standard: "Excellent",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Fair",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
      ],
    },
  },
  Submitted: {
    row: {
      SrNo: "Sr.No",
      name: "Name",
      case_grade: "Case Grade",
      fraud: "Fraud Type",
      grade_status: "Grade Status",
      grade_sub_status: "Grade Sub-Status",
      vendor_assessment: "Vendor Assessment",
      regulatory_details: "Regulatory Details",
      peer_review: "Peer Review",
    },
    column: [
      {
        id: 1,
        name: "Ram Singh - IM",
        case_grade: "Grade 1 : Fraud",
        grade_status: "Grade 1 : Fraud",
        grade_sub_status: "Grade 1 : Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 2,
        name: "Venkata Narasimha Singh - RM",
        case_grade: "Grade 2 : Loss Minimization",
        grade_status: "Documentary Fraud",
        grade_sub_status: "Documentary Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 3,
        name: "Vijay Sharma - NM",
        case_grade: "Vijay Sharma - NM",
        grade_status: "Fake Hospitalisation",
        grade_sub_status: "No Employee Employer Relationship",
        vendor_assessment: "Vendor Assessment",
      },
    ],
    vendorAssessments: {
      row: {
        vendor_name: "Vendor Name",
        report_status: "Report Status",
        report_standard: "Report Standard",
        report_standard_score: "Report Standard Score",
        company_name: "Company name",
        block_completed: "Block Completed",
        block_score: "Block Score",
        quality_score: "Quality Score",
        remarks: "Remarks",
      },
      column: [
        {
          vendor_name: "Akash Sharma",
          report_status: "Fraud",
          report_standard: "Very Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Fraud",
          report_standard: "Below Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Policy Violation",
          report_standard: "Excellent",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Fair",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
      ],
    },
  },
  QC: {
    row: {
      SrNo: "Sr.No",
      name: "Name",
      case_grade: "Case Grade",
      fraud: "Fraud Type",
      grade_status: "Grade Status",
      grade_sub_status: "Grade Sub-Status",
      vendor_assessment: "Vendor Assessment",
      regulatory_details: "Regulatory Details",
      peer_review: "Peer Review",
    },
    column: [
      {
        id: 1,
        name: "Ram Singh - IM",
        case_grade: "Grade 1 : Fraud",
        grade_status: "Grade 1 : Fraud",
        grade_sub_status: "Grade 1 : Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 2,
        name: "Venkata Narasimha Singh - RM",
        case_grade: "Grade 2 : Loss Minimization",
        grade_status: "Documentary Fraud",
        grade_sub_status: "Documentary Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 3,
        name: "Vijay Sharma - NM",
        case_grade: "Vijay Sharma - NM",
        grade_status: "Fake Hospitalisation",
        grade_sub_status: "No Employee Employer Relationship",
        vendor_assessment: "Vendor Assessment",
      },
    ],
    vendorAssessments: {
      row: {
        vendor_name: "Vendor Name",
        report_status: "Report Status",
        report_standard: "Report Standard",
        report_standard_score: "Report Standard Score",
        company_name: "Company name",
        block_completed: "Block Completed",
        block_score: "Block Score",
        quality_score: "Quality Score",
        remarks: "Remarks",
      },
      column: [
        {
          vendor_name: "Akash Sharma",
          report_status: "Fraud",
          report_standard: "Very Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Fraud",
          report_standard: "Below Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Policy Violation",
          report_standard: "Excellent",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Fair",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
      ],
    },
  },
  Recommended: {
    row: {
      SrNo: "Sr.No",
      name: "Name",
      case_grade: "Case Grade",
      fraud: "Fraud Type",
      grade_status: "Grade Status",
      grade_sub_status: "Grade Sub-Status",
      vendor_assessment: "Vendor Assessment",
      regulatory_details: "Regulatory Details",
      peer_review: "Peer Review",
    },
    column: [
      {
        id: 1,
        name: "Ram Singh - IM",
        case_grade: "Grade 1 : Fraud",
        grade_status: "Grade 1 : Fraud",
        grade_sub_status: "Grade 1 : Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 2,
        name: "Venkata Narasimha Singh - RM",
        case_grade: "Grade 2 : Loss Minimization",
        grade_status: "Documentary Fraud",
        grade_sub_status: "Documentary Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 3,
        name: "Vijay Sharma - NM",
        case_grade: "Vijay Sharma - NM",
        grade_status: "Fake Hospitalisation",
        grade_sub_status: "No Employee Employer Relationship",
        vendor_assessment: "Vendor Assessment",
      },
    ],
    vendorAssessments: {
      row: {
        vendor_name: "Vendor Name",
        report_status: "Report Status",
        report_standard: "Report Standard",
        report_standard_score: "Report Standard Score",
        company_name: "Company name",
        block_completed: "Block Completed",
        block_score: "Block Score",
        quality_score: "Quality Score",
        remarks: "Remarks",
      },
      column: [
        {
          vendor_name: "Akash Sharma",
          report_status: "Fraud",
          report_standard: "Very Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Fraud",
          report_standard: "Below Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Policy Violation",
          report_standard: "Excellent",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Fair",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
      ],
    },
  },
  Rejected: {
    row: {
      SrNo: "Sr.No",
      name: "Name",
      case_grade: "Case Grade",
      fraud: "Fraud Type",
      grade_status: "Grade Status",
      grade_sub_status: "Grade Sub-Status",
      vendor_assessment: "Vendor Assessment",
      regulatory_details: "Regulatory Details",
      peer_review: "Peer Review",
    },
    column: [
      {
        id: 1,
        name: "Ram Singh - IM",
        case_grade: "Grade 1 : Fraud",
        grade_status: "Grade 1 : Fraud",
        grade_sub_status: "Grade 1 : Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 2,
        name: "Venkata Narasimha Singh - RM",
        case_grade: "Grade 2 : Loss Minimization",
        grade_status: "Documentary Fraud",
        grade_sub_status: "Documentary Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 3,
        name: "Vijay Sharma - NM",
        case_grade: "Vijay Sharma - NM",
        grade_status: "Fake Hospitalisation",
        grade_sub_status: "No Employee Employer Relationship",
        vendor_assessment: "Vendor Assessment",
      },
    ],
    vendorAssessments: {
      row: {
        vendor_name: "Vendor Name",
        report_status: "Report Status",
        report_standard: "Report Standard",
        report_standard_score: "Report Standard Score",
        company_name: "Company name",
        block_completed: "Block Completed",
        block_score: "Block Score",
        quality_score: "Quality Score",
        remarks: "Remarks",
      },
      column: [
        {
          vendor_name: "Akash Sharma",
          report_status: "Fraud",
          report_standard: "Very Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Fraud",
          report_standard: "Below Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Policy Violation",
          report_standard: "Excellent",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Fair",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
      ],
    },
  },
  Closed: {
    row: {
      SrNo: "Sr.No",
      name: "Name",
      case_grade: "Case Grade",
      fraud: "Fraud Type",
      grade_status: "Grade Status",
      grade_sub_status: "Grade Sub-Status",
      vendor_assessment: "Vendor Assessment",
      regulatory_details: "Regulatory Details",
      peer_review: "Peer Review",
    },
    column: [
      {
        id: 1,
        name: "Ram Singh - IM",
        case_grade: "Grade 1 : Fraud",
        grade_status: "Grade 1 : Fraud",
        grade_sub_status: "Grade 1 : Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 2,
        name: "Venkata Narasimha Singh - RM",
        case_grade: "Grade 2 : Loss Minimization",
        grade_status: "Documentary Fraud",
        grade_sub_status: "Documentary Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 3,
        name: "Vijay Sharma - NM",
        case_grade: "Vijay Sharma - NM",
        grade_status: "Fake Hospitalisation",
        grade_sub_status: "No Employee Employer Relationship",
        vendor_assessment: "Vendor Assessment",
      },
    ],
    vendorAssessments: {
      row: {
        vendor_name: "Vendor Name",
        report_status: "Report Status",
        report_standard: "Report Standard",
        report_standard_score: "Report Standard Score",
        company_name: "Company name",
        block_completed: "Block Completed",
        block_score: "Block Score",
        quality_score: "Quality Score",
        remarks: "Remarks",
      },
      column: [
        {
          vendor_name: "Akash Sharma",
          report_status: "Fraud",
          report_standard: "Very Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Fraud",
          report_standard: "Below Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Policy Violation",
          report_standard: "Excellent",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Fair",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
      ],
    },
  },
  Case: {
    row: {
      SrNo: "Sr.No",
      name: "Name",
      case_grade: "Case Grade",
      fraud: "Fraud Type",
      grade_status: "Grade Status",
      grade_sub_status: "Grade Sub-Status",
      vendor_assessment: "Vendor Assessment",
      regulatory_details: "Regulatory Details",
      peer_review: "Peer Review",
    },
    column: [
      {
        id: 1,
        name: "Ram Singh - IM",
        case_grade: "Grade 1 : Fraud",
        grade_status: "Grade 1 : Fraud",
        grade_sub_status: "Grade 1 : Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 2,
        name: "Venkata Narasimha Singh - RM",
        case_grade: "Grade 2 : Loss Minimization",
        grade_status: "Documentary Fraud",
        grade_sub_status: "Documentary Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 3,
        name: "Vijay Sharma - NM",
        case_grade: "Vijay Sharma - NM",
        grade_status: "Fake Hospitalisation",
        grade_sub_status: "No Employee Employer Relationship",
        vendor_assessment: "Vendor Assessment",
      },
    ],
    vendorAssessments: {
      row: {
        vendor_name: "Vendor Name",
        report_status: "Report Status",
        report_standard: "Report Standard",
        report_standard_score: "Report Standard Score",
        company_name: "Company name",
        block_completed: "Block Completed",
        block_score: "Block Score",
        quality_score: "Quality Score",
        remarks: "Remarks",
      },
      column: [
        {
          vendor_name: "Akash Sharma",
          report_status: "Fraud",
          report_standard: "Very Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Fraud",
          report_standard: "Below Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Policy Violation",
          report_standard: "Excellent",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Fair",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
      ],
    },
  },
  Invoice: {
    row: {
      SrNo: "Sr.No",
      name: "Name",
      case_grade: "Case Grade",
      fraud: "Fraud Type",
      grade_status: "Grade Status",
      grade_sub_status: "Grade Sub-Status",
      vendor_assessment: "Vendor Assessment",
      regulatory_details: "Regulatory Details",
      peer_review: "Peer Review",
    },
    column: [
      {
        id: 1,
        name: "Ram Singh - IM",
        case_grade: "Grade 1 : Fraud",
        grade_status: "Grade 1 : Fraud",
        grade_sub_status: "Grade 1 : Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 2,
        name: "Venkata Narasimha Singh - RM",
        case_grade: "Grade 2 : Loss Minimization",
        grade_status: "Documentary Fraud",
        grade_sub_status: "Documentary Fraud",
        vendor_assessment: "Vendor Assessment",
      },
      {
        id: 3,
        name: "Vijay Sharma - NM",
        case_grade: "Vijay Sharma - NM",
        grade_status: "Fake Hospitalisation",
        grade_sub_status: "No Employee Employer Relationship",
        vendor_assessment: "Vendor Assessment",
      },
    ],
    vendorAssessments: {
      row: {
        vendor_name: "Vendor Name",
        report_status: "Report Status",
        report_standard: "Report Standard",
        report_standard_score: "Report Standard Score",
        company_name: "Company name",
        block_completed: "Block Completed",
        block_score: "Block Score",
        quality_score: "Quality Score",
        remarks: "Remarks",
      },
      column: [
        {
          vendor_name: "Akash Sharma",
          report_status: "Fraud",
          report_standard: "Very Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Fraud",
          report_standard: "Below Average",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "Jane Doe",
          report_status: "Policy Violation",
          report_standard: "Excellent",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Good",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
        {
          vendor_name: "John Smith",
          report_status: "Policy Violation",
          report_standard: "Fair",
          report_standard_score: "20",
          investigator_name: "Mediprobe Services",
          block_completed: 92.86,
          block_score: 46,
          quality_score: 66,
          remarks:
            "Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data Dummy data",
        },
      ],
    },
  },
};
